import React, { useState, useCallback } from "react";
import { inject } from "mobx-react";
import { SmartCaptcha } from "@yandex/smart-captcha";
import { pipe } from "Utils/functionalUtils";
import { Helmet } from "react-helmet-async";

const YandexCaptcha = (props) => {
	let {
		ApplicationModel: { yandexCaptchaKeyClient, sendingStore },
		ipAddress,
	} = props;
	const [token, setToken] = useState("");
	const [status, setStatus] = useState("Ожидание действия");

	const handleNetworkError = useCallback(() => {
		setStatus("Ошибка в соединении");
	}, []);
	const handleSuccess = useCallback(async (token) => {
		setStatus("Проверка");
		setToken(token);
		let result = await sendingStore.onSendYandexCaptcha(ipAddress, token);
		if (Boolean(result)) {
			setStatus("Капча пройдена, ждите или перезагрузите страницу");
			window.location.reload();
		} else {
			setStatus("Капча не пройдена, перезагрузите страницу");
		}
	}, []);
	return (
		<>
			<Helmet>
				<title>Сайт будет доступен после определения, что вы не робот</title>
				<meta
					name="description"
					content={"Сайт будет доступен после определения, что вы не робот"}
				/>
			</Helmet>
			<SmartCaptcha
				sitekey={yandexCaptchaKeyClient}
				onNetworkError={handleNetworkError}
				onSuccess={handleSuccess}
			/>
			<p>Статус: {status}</p>
		</>
	);
};

export default pipe(inject("ApplicationModel"))(YandexCaptcha);
